/**
  * 深色背景 光伏主页 竖堆叠柱状图
  * @param unit 单位
  * @param xData []x轴数据
  * @param dataArr [{name:'',data:[]}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let colorList = [
    { color: "#2E649B", color1: "#48A4FC" },
    { color: "#515BA6", color1: "#7177E2" },
    { color: "#37868A", color1: "#16CDC7" },
    { color: "#AD9B76", color1: "#F5CE82" },
    { color: "#BB8082", color1: "#F98B86" },
  ];
  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    grid: {
      top: "20px",
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#CBCBCB",
          fontSize: 12,
        },
        data: paramObj.xData,
      },
    ],
    yAxis: [
      {
        type: "value",
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },

        axisLabel: {
          color: "#7BA0BC",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#082D50",
          },
        },
      },
    ],
    dataZoom: [
      {
        type: "inside",
      },
    ],
    series: [],
  };
  paramObj.dataArr.forEach((v, i) => {
    option.series.push({
      name: v.name,
      type: "bar",
      stack: "total",
      barMaxWidth: 12,
      emphasis: {
        focus: "series",
      },

      itemStyle: {
        borderRadius:
          i == paramObj.dataArr.length - 1
            ? [12, 12, 0, 0]
            : [0, 0, 0, 0],
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: colorList[i].color1,
            },
            {
              offset: 1,
              color: colorList[i].color,
            },
          ],
        },
      },
      data: v.data,
    });
  });
  

  return option
  
}